import { User, Sparkles, HeartHandshake, Users, Smile, Eye, Palette, ClipboardCheck, Leaf } from "lucide-react";

const MAP = { User, Sparkles, HeartHandshake, Users, Smile, Eye, Palette, ClipboardCheck };

export default function ServiceIcon({ name, className = "h-5 w-5" }) {
  const Icon = MAP[name] || Leaf;
  return <Icon className={className} strokeWidth={1.8} />;
}
